export function getRedirectPath(user, fallback = '', app) {
  if (user.approvalStatus === "pending") {
    const modules = Object.keys(user.modules);
    const _app = modules[0] || app;

    if (_app) {
      return `/${_app}/confirm`;
    }
  }

  if (isSuperAdmin(user)) {
    return '/app/admin/users'
  } else {
    if (user.modules && Object.keys(user.modules).length && process.env.REACT_APP_ENV !== 'demo') {
      const modules = Object.keys(user.modules);
      const f = (fallback || '')[0] === '/' ? (fallback || '').substring(1) : (fallback || '');
      const fallbackRoute = f.split('/');
      if (fallbackRoute.length > 1 && fallbackRoute[0] === 'app' && modules.includes(fallbackRoute[1])) {
        return fallback;
      }

      if (app && app !== 'mmt') {
        return `/app/${app}`;
      }

      if (process.env.REACT_APP_APP) {
        return `/app/${process.env.REACT_APP_APP}`
      }

      if (Object.keys(user.modules).length === 1) {
        return `/app/${Object.keys(user.modules)[0]}`;
      }

      if (Object.keys(user.modules).length >= 2) {
        return `/app`;
      }

      return `/app/${Object.keys(user.modules)[0]}`
    }
    return `/app`;
  }
}

export function isSuperAdmin(user) {
  return user?.role?.id === 'SUPER_ADMIN';
}

export function hasModule(user, module) {
  return user && ((user.modules && user.modules[module.toLowerCase()]) || !user.details);
}

export const tifRoles = {
  AMP: 'Amp',
  PARTNER: 'Partner',
  ADMIN: 'AppAdmin',
}
